export enum SettingsQueryKeys {
  Settings = "settings",
  SportProviders = "sport-providers",
  Telegram = "telegram-settings",
}
